import React, { useState, useEffect, useRef, useContext } from "react";
import { Paper } from "@mui/material";
import { MdManageAccounts } from "react-icons/md";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './../../../../Style/Produce.scss'
import axios from "axios";
import { ApiLink } from '../../../../APILink/ApiLink';
import authHeader from '../../../../Auth/authHeader';
import { errorAlert, handleSuccess } from '../../../../Components/Alerts';
import { FaTable } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { ElementsParagraph, TitleElements } from "../../../../Components/HeadersCRUD-s";
import { LinkAndClickButton } from "../../../../Components/AddElementsButton";
import { FaTimes } from "react-icons/fa";
import { ArticleReceptureDetails } from "./ProduceGrid";
import ReusableServerDataGrid from "../../../../Components/ReusableServerDataGrid";
import { FiscalYearContext } from "../../../../FiscalYear/FiscalYearContext";
import { TextareaAutosize } from '@mui/material';
import PrintFletProdhimin from "../../../../Print/PrintFletProdhimin";
import ButtonGroup from '@mui/material/ButtonGroup';
import MuiButton from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import qs from 'qs';
import '../../../../Produce/StandartProduction/Normativ/NormativProfessional.css';
import './StandardProduceProfessional.css';
import { useLocation } from "react-router-dom";

function StandardProduceForm() {
    const location = useLocation();
    const { fiscalYear } = useContext(FiscalYearContext);
    const editTransaction =
        location?.state?.mode === "edit" && location?.state?.transaction
            ? location.state.transaction
            : null;
    const editTransactionID = Number(editTransaction?.TransactionID || 0);
    const isEditMode = editTransactionID > 0;
    const editInitializedRef = useRef(false);
    const qtyForm3Ref = useRef(null);
    const [produceArticleData, setProduceArticleData] = useState([]);

    const [receptureIDs, setReceptureIDs] = useState([]);
    const [receptureInventory, setReceptureInventory] = useState([]);

    const [openDetails, setOpenDetails] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const [hasElectronicSeal, setHasElectronicSeal] = useState(null);
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const [showCalculation, setShowCalculation] = useState(false);

    const [detailsPaginationModel, setDetailsPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [detailsSortModel, setDetailsSortModel] = useState([]);
    const [detailsFilterModel, setDetailsFilterModel] = useState({ items: [] });
    const [detailsQuickFilter, setDetailsQuickFilter] = useState([]);

    const [articleProductions, setArticlProductions] = useState([]);
    const [articleUnit, setArticleUnit] = useState(null);

    const [transactionID, setTransactionID] = useState(0);
    const [articleProductionID, setArticleProductionID] = useState(0);
    const [qty, setQty] = useState(0);
    const [date, setDate] = useState("");
    const [comment, setComment] = useState("");
    const [invoiceNR, setInvoiceNR] = useState("");
    const [unId, setUnID] = useState('')

    const [changeButton, setChangeButton] = useState(false)
    const [headerData, setHeaderData] = useState([]);
    const [companiesData, setCompaniesData] = useState([]);
    const [producedSummaryDb, setProducedSummaryDb] = useState(null);
    const [receptureWarning, setReceptureWarning] = useState("");

    const [disabledButton, setDisabledButton] = useState(false);
    const [disabledQty, setDisabledQty] = useState(false);
    const [editButton, setEditButton] = useState(false);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const handleEnable = () => {
        setForm1IsDisabled(true);
    }

    const headers = authHeader();

    const [data, setData] = useState([]);

    const [form1IsDisabled, setForm1IsDisabled] = useState(false);

    const fetchArticlesProduction = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CompoundArticle', { headers });
            setArticlProductions(response.data);
            if (response.data && response.data.length > 0) {
                setArticleUnit(response.data[0].UnitName);
            }
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchrecepture = async (id) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'StandardProduce/receptureDetails', {
                headers,
                params: { compoundArticleID: id }
            });

            setData(response.data);
            setShowTable((response.data || []).length > 0);
            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }

            return [];
        }
    };

    const fetchLastInvoiceNr = async (fiscalY) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'StandardProduce/nextInvoice', { headers, params: { fiscalYear: fiscalY } });
            setInvoiceNR(response.data.nextInvoiceNr);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchHeaderData = async (invNumber) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Produce/GetPrintHeaderDetails', { headers, params: { invNumber: invNumber, actionType: "PRD", fiscalYear: fiscalYear } });
            setHeaderData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchCompaniesData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyDetails', { headers });
            setCompaniesData(response.data);
            setHasElectronicSeal(response.data[0].ElectronicSeal);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchUnId = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'UserDetails/GetUnitIDByUserID', { headers });
            setUnID(response.data.CompanyUnit_ID);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };
    const fetchArticlesInventory = async (articleIDs) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingBooks/inventoryByManyArticleIDs', {
                headers,
                params: {
                    articleIDs: articleIDs,  // Lista e ID-ve
                    fiscalYear: fiscalYear
                },
                paramsSerializer: (params) => {
                    return qs.stringify(params, { arrayFormat: 'repeat' });
                }
            });
            setReceptureInventory(response.data);
        } catch (error) {
            console.error("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        if (!date) {
            errorAlert("Ju lutem plotësoni datën!");
            return;
        }

        const stateDate = {
            Date: date,
            InvoiceNr: invoiceNR,
            Comment: comment,
            CompanyUnitID: unId > 0 ? unId : null

        };
        axios.post(ApiLink.API_URL + 'StandardProduce/transactions', stateDate, { headers })
            .then((response) => {
                // handleSuccess("Accounting Sheet Added Successfully");
                const createdTransactionId = Number(response?.data?.transactionID || 0);
                handleEnable();
                setOpenDetails(true);
                setTransactionID(createdTransactionId);
                fetchHeaderData(invoiceNR);
                setChangeButton(true);
            })
            .catch((error) => {
                console.error("Gabim nga serveri:", error);

                if (error.response) {
                    console.error("Statusi i gabimit:", error.response.status);
                    console.error("Mesazhi nga serveri:", error.response.data);

                    // Shfaq gabimin specifik nga backend-i
                    errorAlert(`Gabim (${error.response.status}): ${error.response.data}`);
                } else if (error.request) {
                    console.error("Nuk ka përgjigje nga serveri:", error.request);
                    errorAlert("Nuk ka përgjigje nga serveri. Kontrolloni lidhjen.");
                } else {
                    console.error("Gabim gjatë kërkesës:", error.message);
                    errorAlert("Gabim gjatë dërgimit të kërkesës.");
                }
            });
    };

    const saveAndNew = () => {
        setChangeButton(false);
        setOpenDetails(false);
        setShowTable(false);
        setForm1IsDisabled(false);
        setShowCalculation(false);
        setProducedSummaryDb(null);
        setReceptureWarning("");
        setArticleCompoundfield(null);
        setArticleProductionID(0);
        setQty(0);
        fetchLastInvoiceNr(fiscalYear);
        setDate("");
        setComment("");
        setDisabledQty(false);
        setDisabledButton(false);
    }

    const toInputDate = (value) => {
        if (!value) return "";
        const dt = new Date(value);
        if (Number.isNaN(dt.getTime())) return "";
        const year = dt.getFullYear();
        const month = String(dt.getMonth() + 1).padStart(2, "0");
        const day = String(dt.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const getFieldValue = (obj, keys, fallback = null) => {
        if (!obj) return fallback;
        for (const key of keys) {
            if (obj[key] !== undefined && obj[key] !== null) {
                return obj[key];
            }
        }
        return fallback;
    };

    const fetchProducedSummaryFromDb = async (targetTransactionID = transactionID) => {
        if (!targetTransactionID) {
            return null;
        }

        try {
            const response = await axios.get(ApiLink.API_URL + 'StandardProduce/producedSummary', {
                headers,
                params: { transactionID: targetTransactionID }
            });

            const producedItem = response.data || null;
            if (!producedItem) {
                return null;
            }

            const articleName = getFieldValue(producedItem, ["ArticleName", "articleName"], "");
            const qtyValue = getFieldValue(producedItem, ["Qty", "qty", "QtyInput", "qtyInput"], 0);
            const priceValue = getFieldValue(producedItem, ["CmimiMesatar", "cmimiMesatar", "PriceWithoutVAT", "priceWithoutVAT"], 0);
            const totalValue = getFieldValue(producedItem, ["TotalAmount", "totalAmount", "Total", "total"], 0);
            const articleIdValue = getFieldValue(producedItem, ["ArticlesID", "articlesID", "ArticleID", "articleID"], 0);

            setProducedSummaryDb({
                recepture: articleName,
                qty: Number(qtyValue || 0),
                price: Number(priceValue || 0),
                value: Number(totalValue || 0),
                articleProductionID: Number(articleIdValue || 0),
            });

            return producedItem;
        } catch (error) {
            // Fallback te kalkulimi i UI nëse dështon fetch-i nga databaza.
            return null;
        }
    };

    const handleNewSubmit = (event, action) => {
        event.preventDefault();

        if (!articleProductionID) {
            errorAlert("Zgjedheni artikullin, për të vazhduar");
            return
        }
        if (!qty) {
            errorAlert("Plotësoni sasinë, për të vazhduar");
            return
        }
        if (!data || data.length === 0) {
            const msg = "Ky normativ nuk ka receptura të regjistruara. Nuk mund të prodhoni pa receptura.";
            setReceptureWarning(msg);
            errorAlert(msg);
            return;
        }

        const payload = {
            ArtProdDto: {
                TransactionID: transactionID,
                ArticleProductionID: articleProductionID,
                Date: date,
                QtyInput: qty,
                Price: totalAvg,
            },
            ReceptureDetails: data,
        };
        axios.post(ApiLink.API_URL + "StandardProduce/execute", payload, { headers, params: { action: action } })
            .then(() => {
                // handleSuccess("Receptura u shtua me sukses");
                setShowCalculation(true);
                setEditButton(false);
                setDisabledButton(true);
                setDisabledQty(true);
                fetchProducedSummaryFromDb(payload.ArtProdDto.TransactionID);
            })
            .catch((error) => {
                console.error("Gabim gjatë dërgimit:", error);

                if (error.response) {
                    console.error("Përgjigja nga serveri:", error.response.data);
                    const backendMessage =
                        error.response?.data?.message ||
                        error.response?.data?.errorMessage ||
                        error.response?.data ||
                        "";

                    if (error.response.status === 409) {
                        errorAlert(backendMessage || "Konflikt në ruajtje.");
                    } else if (error.response.status === 400) {
                        errorAlert(backendMessage || "Të dhënat nuk janë të sakta. Kontrolloni nëse keni plotësuar çdo fushë.");
                    } else if (error.response.status === 500) {
                        errorAlert(`Gabim i brendshëm i serverit: ${backendMessage}`);
                    } else {
                        errorAlert(`Ndodhi një gabim: ${backendMessage}`);
                    }
                } else if (error.request) {
                    errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen tuaj me internetin.");
                } else {
                    errorAlert("Ndodhi një gabim i panjohur gjatë dërgimit të të dhënave.");
                }
            });
    };

    //Pjesa per select input field artikull te perber
    const [articleCompound, setArticleCompoundfield] = useState(null)
    const handleAutocompleteChangearticleProduction = async (event, value) => {
        if (value && value.ArticleID) {
            setArticleProductionID(value.ArticleID);
            setArticleCompoundfield(value);
            const receptures = await fetchrecepture(value.ArticleID);
            if (!receptures || receptures.length === 0) {
                const msg = "Ky normativ nuk ka receptura të regjistruara.";
                setReceptureWarning(msg);
                errorAlert(msg);
            } else {
                setReceptureWarning("");
            }
        } else {
            setArticleProductionID(0);
            setReceptureWarning("");
            setShowTable(false);
        }
    };

    const defaultPropsArticleProduction = {
        options: articleProductions,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <li
                {...props}
                style={{
                    borderBottom: "1px solid #e3ece7",
                    padding: "10px 12px",
                    alignItems: "flex-start",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "3px", width: "100%" }}>
                    <div
                        style={{
                            color: "#4f6f61",
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "0.02em",
                            textTransform: "uppercase",
                            lineHeight: 1.2,
                        }}
                    >
                        {option.Barcode} • {option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"}
                    </div>
                    <div style={{ color: "#1f3a36", fontSize: "13px", fontWeight: 700, lineHeight: 1.25 }}>
                        {option.ArticleName}
                    </div>
                </div>
            </li>
        ),
    };

    const changeButtons = () => {
        setEditButton(true)
        setDisabledQty(false);
        fetchProducedSummaryFromDb(transactionID);

    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let nextField;
            switch (e.target.id) {
                case 'ArticleID':
                    nextField = document.getElementById('Qty');
                    break;
                case 'Qty':
                    if (editButton === true) {
                        handleNewSubmit(e, "edit");
                    } else if (editButton === false) {
                        handleNewSubmit(e, "insert");
                    }
                    // nextField = document.getElementById('ArticlesID');
                    break;
                default:
                    return;
            }
            if (nextField && nextField.select) {
                nextField.focus();
                nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
            }
        }
    };

    // const checkStockAvailability = (newRows, inventory) => {
    //     console.log(inventory);

    //     const insufficientStock = newRows.filter(row => {
    //         const inventoryItem = inventory.find(inv => inv.ArticleID === row.ArticleID);
    //         return inventoryItem && inventoryItem.TotalQtyInStock !== undefined && row.qty > inventoryItem.TotalQtyInStock;
    //     });

    //     if (insufficientStock.length < 0) {
    //         alert("Disa artikuj nuk kanë stok të mjaftueshëm!");
    //     }
    // };



    //i shfaq recepturat ne momentin qe zgjedhet Normativi, dhe me pas sa her qe sasia ndryshon ne normativ, kalkulohen recepturat
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const newRows = data.map((item, index) => ({
            id: index + 1, // Përdor index + 1 në vend të ++index
            articleID: item.ArticleID, // Shtojmë ArticleID për krahasim
            recepture: item.ArticleName,
            qty: qty !== 0 ? Number(item.Qty) * Number(qty) : item.Qty,
            price: item.CmimiMesatar,
            value: qty !== 0 ? (Number(item.CmimiMesatar) * (Number(item.Qty) * Number(qty))) : item.TotalAmount,
            artUnit: item.UnitName
        }));

        setRows(newRows);
    }, [qty, data]);



    // //I vvendos id e recepturave ne nje array te vetme
    useEffect(() => {
        setReceptureIDs(data.map(item => item.ArticlesID));
    }, [data]);

    // useEffect(() => {
    //     console.log(receptureIDs);
    // }, [receptureIDs]);

    useEffect(() => {
        if (receptureIDs.length > 0) {
            fetchArticlesInventory(receptureIDs)
        }
    }, [receptureIDs])

    //ruhet totali i vleres se seciles recepture
    const [totalAvg, setTotalAvg] = useState(0);

    useEffect(() => {
        if (data.length > 0 && qty > 0) {
            let total = data.reduce((sum, item) => sum + item.TotalAmount, 0);
            setTotalAvg(total);
        } else {
            setTotalAvg(0); // Reset në rast se s'ka të dhëna
        }
    }, [data, qty]);

    // Përditëso array-n me të dhëna dinamike
    useEffect(() => {
        setProduceArticleData([
            {
                id: 1,
                ArticleName: articleCompound ? articleCompound.ArticleName : "",
                Qty: qty,
                CmimiMesatar: totalAvg,
                TotalAmount: Number(qty) * Number(totalAvg),
                TransactionID: transactionID,
                UnitName: articleUnit
            }
        ]);
    }, [articleCompound, qty, totalAvg, transactionID]);

    const produceArticleRow = produceArticleData.map((item, index) => ({
        id: ++index,
        recepture: item.ArticleName,
        qty: item.Qty,
        price: item.CmimiMesatar,
        value: item.TotalAmount,
    }));

    const producedSummaryLive = produceArticleRow[0] || null;
    const producedSummary = editButton ? producedSummaryLive : (producedSummaryDb || producedSummaryLive);

    useEffect(() => {
        fetchArticlesProduction();
        fetchCompaniesData();
        fetchUnId();
    }, []);

    useEffect(() => {
        if (!isEditMode) {
            fetchLastInvoiceNr(fiscalYear);
        }
    }, [fiscalYear, isEditMode]);

    useEffect(() => {
        if (!isEditMode || !editTransaction || !articleProductions.length || editInitializedRef.current) {
            return;
        }

        const initializeEditMode = async () => {
            setForm1IsDisabled(true);
            setOpenDetails(true);
            setChangeButton(true);
            setShowCalculation(true);
            setDisabledButton(true);
            setDisabledQty(true);
            setEditButton(false);
            setReceptureWarning("");

            const txId = Number(editTransaction.TransactionID || 0);
            setTransactionID(txId);
            setDate(toInputDate(editTransaction.Date));
            setComment(editTransaction.Coment || "");
            setInvoiceNR(editTransaction.InvoiceNr || "");

            if (editTransaction.InvoiceNr) {
                fetchHeaderData(editTransaction.InvoiceNr);
            }

            const producedItem = await fetchProducedSummaryFromDb(txId);
            const producedArticleID = Number(getFieldValue(producedItem, ["ArticlesID", "articlesID", "ArticleID", "articleID"], 0));
            const producedQty = Number(getFieldValue(producedItem, ["Qty", "qty", "QtyInput", "qtyInput"], 0));

            if (producedQty > 0) {
                setQty(producedQty);
            }

            if (producedArticleID > 0) {
                setArticleProductionID(producedArticleID);
                const selectedArticle = articleProductions.find(
                    (item) => Number(item.ArticleID) === producedArticleID
                );
                if (selectedArticle) {
                    setArticleCompoundfield(selectedArticle);
                }

                const receptures = await fetchrecepture(producedArticleID);
                setShowTable((receptures || []).length > 0);
            }
        };

        editInitializedRef.current = true;
        initializeEditMode();
    }, [isEditMode, editTransaction, articleProductions]);

    useEffect(() => {
        if (showCalculation && editButton && qtyForm3Ref.current) {
            qtyForm3Ref.current.focus();
            qtyForm3Ref.current.select?.();
        }
    }, [showCalculation, editButton]);

    return (
        <div className="NewProduce__Container normativ-pro produce-pro" style={{ paddingTop: "12px" }}>
            <div className="normativ-pro-header produce-pro-header">
                <div className="normativ-pro-header__text">
                    <h2 className="normativ-pro-header__title">Krijo Prodhim të ri</h2>
                    <p className="normativ-pro-header__subtitle">
                        Forma e prodhimit me kalkulim automatik të recepturave dhe printim profesional të fletës së prodhimit.
                    </p>
                </div>
                <div className="normativ-pro-header__actions produce-pro-header__actions">
                    {changeButton ? (
                        <>
                            <div className="produce-pro-print-wrap">
                                <ButtonGroup
                                    variant="contained"
                                    ref={anchorRef}
                                >
                                    <PrintFletProdhimin details={headerData} companyDetails={companiesData} produceArticle={produceArticleData} recepture={rows} hasElectronicSeal={hasElectronicSeal} />
                                    <MuiButton
                                        className="produce-pro-print-toggle"
                                        aria-controls={open ? 'split-button-menu' : undefined}
                                        aria-expanded={open ? 'true' : undefined}
                                        aria-haspopup="menu"
                                        onClick={handleToggle}
                                    >
                                        <ArrowDropDownIcon />
                                    </MuiButton>
                                </ButtonGroup>
                                <Popper
                                    sx={{ zIndex: 1 }}
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    role={undefined}
                                    transition
                                    disablePortal
                                >
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin:
                                                    placement === 'bottom' ? 'center top' : 'center bottom',
                                            }}
                                        >
                                            <Paper className="produce-pro-popover">
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={hasElectronicSeal}
                                                                onChange={(event) => setHasElectronicSeal(event.target.checked)}
                                                            />
                                                        }
                                                        label="Shfaq Vulen Elektronike"
                                                    />
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </div>
                            <div>
                                <LinkAndClickButton
                                    text="Ruaj & i Ri"
                                    link="#"
                                    onClick={saveAndNew}
                                />
                            </div>
                            <div>
                                <LinkAndClickButton
                                    text="Mbyll"
                                    icon={<FaTimes />}
                                    link="/produc/produce"
                                />
                            </div>
                        </>
                    ) : (
                        <div>
                            <LinkAndClickButton
                                text="Mbyll"
                                icon={<FaTimes />}
                                link="/produc/produce"
                            />
                        </div>
                    )}
                </div>
            </div>
            <Paper className="normativ-pro-main-card produce-pro-main-card">
                <div className="NewProduce__Container__FirstForm">
                    <div className="produce-pro-step-head">
                        <span className="produce-pro-step-badge">Hapi 1</span>
                        <div className="produce-pro-step-text">
                            <h4>Të dhënat bazë të fletës së prodhimit</h4>
                            <p>Vendos datën dhe përshkrimin. Numri i fletës gjenerohet automatikisht.</p>
                        </div>
                    </div>
                    <form
                        className="header_paper normativ-pro-select-form"
                        onKeyPress={handleKeyPress}>
                        <Box
                            noValidate
                            autoComplete="off"
                        >
                            <div className="NewProduce__Container__FirstForm__Row1 produce-pro-header-fields" >
                                <div className="NewProduce__Container__FirstForm__Row1__div produce-pro-header-field">
                                    <TextField
                                        className="NewProduce__Container__Form__TextField__1"
                                        required
                                        id="invoiceNR"
                                        label="Numri i Fletë Prodhimit"
                                        variant="outlined"
                                        type="text"
                                        name='InvoiceNr'
                                        value={"PRD-" + fiscalYear + "-" + invoiceNR}
                                        onChange={event => setInvoiceNR(event.target.value)}
                                        disabled={form1IsDisabled}
                                        autoComplete="off"
                                        aria-readonly
                                    />
                                </div>
                                <div className="NewProduce__Container__FirstForm__Row1__div produce-pro-header-field">
                                    <TextField
                                        className="NewProduce__Container__Form__TextField__1"
                                        id="date"
                                        type="date"
                                        variant="outlined"
                                        name='Date'
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        disabled={form1IsDisabled}
                                        inputProps={{
                                            min: minDate, // Kufizimi minimal i datës
                                            max: maxDate, // Kufizimi maksimal i datës
                                        }}
                                    />
                                </div>
                                <div className="NewProduce__Container__FirstForm__Row1__div produce-pro-header-field produce-pro-header-field--comment">
                                    <TextareaAutosize
                                        className="NewProduce__Container__Form__Description"
                                        id="Description"
                                        placeholder='Përshkrimi'
                                        type="text"
                                        autoComplete='off'
                                        name='Description'
                                        value={comment}
                                        onChange={event => setComment(event.target.value)}
                                        style={{ resize: 'none' }}
                                    />

                                </div>
                            </div>
                        </Box>
                    </form>

                    {
                        openDetails && !showCalculation ?
                            <div className="SalesDetail__Container normativ-pro-detail-shell">
                                <div className="normativ-pro-detail-bg">
                                    <div className="produce-pro-step-head produce-pro-step-head--compact">
                                        <span className="produce-pro-step-badge">Hapi 2</span>
                                        <div className="produce-pro-step-text">
                                            <h4>Zgjidh produktin dhe sasinë për prodhim</h4>
                                            <p>Pas klikimit në Prodho, llogaritja ruhet dhe paraqitet përmbledhja më poshtë.</p>
                                        </div>
                                    </div>
                                    <div className="normativ-pro-block-title">Parametrat e Prodhimit</div>
                                    <form className='header_paper normativ-pro-detail-form produce-pro-detail-form' onKeyPress={handleKeyPress}>
                                        <Box
                                            sx={{
                                                '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <div className='NewProduce__Container__FirstForm__Row1'>
                                                <div className="produce-pro-article-select">
                                                    <Autocomplete
                                                        fullWidth
                                                        {...defaultPropsArticleProduction}
                                                        id="ArticleID"
                                                        disabled={disabledButton}
                                                        includeInputInList
                                                        value={articleCompound}
                                                        onChange={handleAutocompleteChangearticleProduction}
                                                        isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                style={{ width: "100%" }}
                                                                {...params}
                                                                label="Kerko Artikullin"
                                                            />
                                                        )}
                                                        ListboxProps={{
                                                            style: {
                                                                maxHeight: '165px',
                                                                minHeight: '165px',
                                                                overflowY: 'auto',
                                                                overflowX: 'hidden',
                                                                WebkitOverflowScrolling: 'touch',
                                                                paddingTop: 0,
                                                                paddingBottom: 0,
                                                                borderRadius: '10px',
                                                                border: '1px solid #d5e3dc',
                                                                boxShadow: '0 10px 24px rgba(31, 58, 54, 0.14)',
                                                                background: '#ffffff',
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                <div className='box3 produce-pro-qty-field'>
                                                    <TextField
                                                        className="AccountingSheet__Container__Form__TextField__5"
                                                        id="Qty"
                                                        label="Sasia"
                                                        variant="outlined"
                                                        autoComplete="off"
                                                        name='QTY'
                                                        disabled={disabledQty}
                                                        value={qty}
                                                        onChange={event => { setQty(event.target.value); }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </div>
                                                {
                                                    editButton ?
                                                        <div className="butonat normativ-pro-inline-actions">
                                                            <button type="submit"
                                                                disabled={!data || data.length === 0}
                                                                className="btn btn-primary float-end normativ-pro-submit-btn"
                                                                onClick={(event) => handleNewSubmit(event, "edit")}
                                                            >Ndrysho</button>
                                                        </div>
                                                        :
                                                        <div className="butonat normativ-pro-inline-actions">
                                                            <button type="submit"
                                                                disabled={disabledButton || !data || data.length === 0}
                                                                className="btn btn-primary float-end normativ-pro-submit-btn"
                                                                onClick={(event) => handleNewSubmit(event, "insert")}
                                                            >Prodho</button>
                                                        </div>
                                                }
                                            </div>
                                            {receptureWarning && (
                                                <div className="produce-pro-warning" role="alert">
                                                    {receptureWarning}
                                                </div>
                                            )}
                                        </Box>
                                    </form>
                                </div>
                            </div>
                            : !openDetails && <div className="normativ-pro-continue-wrap produce-pro-continue-wrap">
                                <div className="produce-pro-continue-note">Pasi të plotësosh të dhënat bazë, vazhdo me konfigurimin e prodhimit.</div>
                                <button variant="contained"
                                    type="submit"
                                    style={{ width: "100%", maxWidth: "420px", height: "48px", border: "none" }}
                                    disabled={form1IsDisabled}
                                    onClick={handleSubmit}
                                    className="button-15 normativ-pro-continue-btn"
                                >
                                    <FaTable />  Vazhdo me prodhimin e produktit
                                </button>
                            </div>
                    }

                    {
                        showCalculation ?
                            <div className="produce-pro-block">
                                <div className="produce-pro-step-head produce-pro-step-head--compact">
                                    <span className="produce-pro-step-badge">Hapi 3</span>
                                    <div className="produce-pro-step-text">
                                        <h4>Përmbledhja finale</h4>
                                        <p>Kontrollo rezultatin dhe përdor Ndrysho vetëm nëse duhet korrigjim i sasisë.</p>
                                    </div>
                                </div>
                                <div className="normativ-pro-block-title">Përmbledhja e Produktit të Prodhuar</div>
                                <div className="produce-pro-summary-card">
                                    <div className="produce-pro-summary-grid">
                                        <div className="produce-pro-summary-item produce-pro-summary-item--main">
                                            <span className="produce-pro-summary-label">Produkti i prodhuar</span>
                                            <strong className="produce-pro-summary-value">{producedSummary?.recepture || "-"}</strong>
                                        </div>
                                        <div className="produce-pro-summary-item">
                                            <span className="produce-pro-summary-label">Sasia</span>
                                            {editButton ? (
                                                <TextField
                                                    inputRef={qtyForm3Ref}
                                                    className="AccountingSheet__Container__Form__TextField__5"
                                                    id="Qty"
                                                    label="Sasia"
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    name='QTY'
                                                    value={qty}
                                                    onChange={event => setQty(event.target.value)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    size="small"
                                                />
                                            ) : (
                                                <strong className="produce-pro-summary-value">{Number(producedSummary?.qty || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                                            )}
                                        </div>
                                        <div className="produce-pro-summary-item">
                                            <span className="produce-pro-summary-label">Cmimi Blerjes</span>
                                            <strong className="produce-pro-summary-value">{Number(producedSummary?.price || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</strong>
                                        </div>
                                        <div className="produce-pro-summary-item">
                                            <span className="produce-pro-summary-label">Vlera</span>
                                            <strong className="produce-pro-summary-value">{Number(producedSummary?.value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</strong>
                                        </div>
                                    </div>

                                    <div className="produce-pro-summary-actions">
                                        <button
                                            type="button"
                                            className="button-15 produce-pro-summary-edit-btn"
                                            onClick={editButton ? (event) => handleNewSubmit(event, "edit") : changeButtons}
                                            disabled={!editButton && (!data || data.length === 0)}
                                        >
                                            {editButton ? "Ruaj" : "Ndrysho"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                    {
                        showTable ?
                            <div className="produce-pro-block">
                                <div className="normativ-pro-block-title normativ-pro-block-title--grid">Recepturat e përdorura për prodhim</div>
                                <ElementsParagraph text="Në tabelë janë paraqitur recepturat që shërbejnë për ta prodhuar produktin e zgjedhur." />
                                <div className="normativ-pro-grid-wrap">
                                    <ReusableServerDataGrid
                                        columns={ArticleReceptureDetails}
                                        rows={rows}
                                        showPayment={false}
                                        showViewAction={false}
                                        showEditAction={false}
                                        showDeleteAction={false}
                                        height={420}
                                        rowCount={rows.length}
                                        paginationModel={detailsPaginationModel}
                                        setPaginationModel={setDetailsPaginationModel}
                                        sortModel={detailsSortModel}
                                        setSortModel={setDetailsSortModel}
                                        filterModel={detailsFilterModel}
                                        setFilterModel={setDetailsFilterModel}
                                        quickFilter={detailsQuickFilter}
                                        setQuickFilter={setDetailsQuickFilter}
                                    />
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </Paper >
        </div >
    );
}

export default StandardProduceForm;